import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { cancellaAccettazioneLogica, caricaAccettazioniNre } from "app/services/Accettazione/accettazioneServices";
import { useNavigate } from "react-router-dom";
import { getElement, getQueryGetDto } from "../ServiceController";
import { NotificationManager } from "react-notifications";
import { handlePdfFattura } from "app/views/pdf/pdfViewService";
import LoadingSpinner from "@gull/components/Loading/LoadingSpinner";
import BasicModal from "app/views/ui-kits/modals/BasicModal";
import webSocketService from "app/services/websocket";
import { getValoreVariabileUtil } from "app/services/VariabiliStrutture/VariabiliStrutture";
import RitiriModalForm from "../Ritiri/RitiriModalForm";
import { formatEuro } from "app/utility/numbers";
import { formattaData, formattaDataOraHHmm, formattaDataOraHHmmss, getDataPerDataPicker } from "app/utility/dataOra";
import { Breadcrumb } from "@gull";

const ImpegnativeNre = () => {
    const dispatch = useDispatch();
    const [isLoading, setLoading] = useState(true);
    const [elencoAnagrafiche, setElencoAnagrafiche] = useState([]);
    const [dataPrenotazione, setSelectedDate] = useState(getDataPerDataPicker(Date.now()));
    const [isDelete, setIsDelete] = useState(false);
    const [abilitaWorkList, setAbilitaWorkList] = useState(false);
    const [idAccettazione, setIDAccettazione] = useState(0);
    const navigate = useNavigate();
    const [idRitiro, setIdRitiro] = useState(0);
    const [show, setShow] = useState(false);
    const [modalBody, setModalBody] = useState("Vuoi cancellare l'accettazione selezionata ?");
    const [showConfirm, setShowConfirm] = useState(true);

    const base64ToArrayBuffer = (base64) => {
        const binaryString = window.atob(base64);
        const len = binaryString.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        return bytes.buffer;
    };

    const stampaReferto = (iddettaglio) => {
        NotificationManager.listNotify?.forEach((n) => NotificationManager.remove({ id: n.id }));
        const payload = {
            IDDettaglio: iddettaglio
        }
        dispatch(getQueryGetDto("referti/StampaReferto", payload))
            .then((data) => {
                if (data.isSuccess) {
                    var arrayBuffer = base64ToArrayBuffer(data.data);
                    const blob = new Blob([arrayBuffer], { type: "application/pdf" });
                    const url = window.URL.createObjectURL(blob);
                    window.open(url, "_blank");
                    window.URL.revokeObjectURL(url);
                } else {
                    NotificationManager.error(data.message, "Errore");
                }
            })
            .catch((error) => {
                NotificationManager.error("Error fetching data", "Errore");
                console.error('Error fetching data:', error);
            });
    }

    const formatImpegnativa = (item) => {
        const impegnativa = item.impegnativa;
        if (!impegnativa) return null;

        const tipoBadgeMap = {
            0: { label: "Privato", className: "bg-dark" },
            1: { label: "Esente", className: "bg-danger" },
            2: { label: "Ticket", className: "bg-success" },
            3: { label: "Omaggio", className: "bg-warning" },
            4: { label: "Grande cliente", className: "bg-primary" },
        };

        const tipoInfo = tipoBadgeMap[impegnativa.idtipoAccettazione];

        return (
            <div className="d-flex align-items-center w-100">
                {/* SINISTRA: può andare a capo */}
                <div className="d-flex flex-wrap align-items-center gap-2">
                    {tipoInfo && (
                        <span className={`badge ${tipoInfo.className}`}>
                            {tipoInfo.label}
                        </span>
                    )}

                    {impegnativa.codice && (
                        <span className="text-body">
                            <span className="fw-semibold">Codice:</span> {impegnativa.codice}
                        </span>
                    )}

                    {impegnativa.esenzioniAsString && (
                        <span className="text-muted">
                            <span className="fw-semibold">Esenzione:</span> {impegnativa.esenzioniAsString}
                        </span>
                    )}
                </div>

                {/* DESTRA: mai a capo, sempre allineata */}
                <div className="ms-auto d-flex align-items-center flex-nowrap">
                    {impegnativa.annullata ? (
                        <span className="badge bg-danger p-2">
                            <i className="i-Delete-File me-1"></i> Ricetta Annullata
                        </span>
                    ) : (
                        <>
                            {/* colonna data fissa */}
                            <span title="Data Prenotazione"
                                className="text-body calendar text-end me-3 d-inline-block"
                                style={{ width: 140 }}
                            >
                                <b>
                                    <i className="i-Calendar-4"></i>
                                    {formattaData(impegnativa.dataPrenotazione)}
                                </b>
                            </span>

                            {impegnativa.statoImp == 1 && (
                                <span className="badge bg-secondary p-2 w-100">
                                    <i className="i-Lock-2 me-1"></i> Ricetta in carico
                                </span>
                            )}

                            {impegnativa.statoImp == 2 && (
                                <span className="badge bg-success p-2" title="Ricetta Erogata">
                                    <i className="i-Big-Data me-1"></i> Ricetta Erogata {formattaData(item.dataEsecuzione)}
                                </span>
                            )}
                        </>
                    )}
                </div>
            </div>
        );

    };

    const handleSelectChange = (event, idAnagrafica) => {
        const selectedOptionValue = event.target.value;
        const [azione, idGenerico] = selectedOptionValue.split('_');
        if (azione === "1") {
            navigate(`/accettazione/form/${idAnagrafica}/${idGenerico}`);
        }
        else if (azione === "3") {
            stampaReferto(idGenerico);
        }
        else {
            stampaFattura(idGenerico);
        }
    };

    const stampaFattura = (idFattura) => {
        NotificationManager.listNotify?.forEach((n) => NotificationManager.remove({ id: n.id }));
        setLoading(true);
        dispatch(getElement('Fatture/StampaFattura', idFattura))
            .then((data) => {
                if (data.isSuccess) {
                    setTimeout(() => {
                        handlePdfFattura(data.dataFattura);
                    }, 500);
                } else {
                    NotificationManager.error(data.message, "Errore");
                }
            }).catch((error) => {
                NotificationManager.error("Error fetching data", "Errore");
                console.error('Error submiting data:', error);
            }).finally(() => {
                setLoading(false);
            });
    }

    const handleCarica = (dataPrenotazione) => {
        setLoading(true);
        dispatch(caricaAccettazioniNre(dataPrenotazione))
            .then((data) => {
                setElencoAnagrafiche(data || []);
                setLoading(false);
            })
            .catch((error) => {
                console.log(error);
                setLoading(false);
            });
    };

    useEffect(() => {
        handleCarica(dataPrenotazione);
    }, []);

    /* gestione worklist*/
    useEffect(() => {
        const fetchValore = async () => {
            const WORKLIST_SOCKET = await getValoreVariabileUtil(dispatch, 'WORKLIST_SOCKET');
            if (WORKLIST_SOCKET === "1") {
                setAbilitaWorkList(true);
                await webSocketService.initialize();
            }
        };

        fetchValore();
    }, []);

    const handleDateChange = (event) => {
        setSelectedDate(event.target.value);
        handleCarica(event.target.value);
    };

    const handleDelete = (task) => {
        // Trova tutte le impegnative di tipo 1 (Esente) o 2 (Ticket)
        const impegnativeTipo1o2 = (task?.dettaglioAccettaziones || [])
            .map(d => d?.impegnativa)
            .filter(imp => imp && (imp.idtipoAccettazione === 1 || imp.idtipoAccettazione === 2));

        // Se non ce ne sono, si può cancellare liberamente
        let canDelete = true;

        if (impegnativeTipo1o2.length > 0) {
            // Si può procedere SOLO se TUTTE sono annullate
            canDelete = impegnativeTipo1o2.every(imp => imp.annullata === true);
        }

        if (canDelete) {
            setModalBody("Vuoi cancellare l'accettazione selezionata ?");
            setShowConfirm(true);
            setIsDelete(true);
            setIDAccettazione(task.id);
        } else {
            setModalBody(
                "Non è possibile cancellare questa accettazione. " +
                "Apri l'accettazione e annulla o rilascia tutte le impegnative di tipo Esente/Ticket " +
                "prima di poter procedere."
            );
            setShowConfirm(false);
            setIsDelete(true);
            setIDAccettazione(0); // non impostiamo l'id perché non si può confermare
        }
    };

    const handleCloseDelete = () => {
        setIsDelete(false);
        setIDAccettazione(0);
        setShowConfirm(true);
        setModalBody("Vuoi cancellare l'accettazione selezionata ?");
    };

    const handleConfermaCancella = () => {
        // cancellaz accettazione 
        setLoading(true);
        dispatch(cancellaAccettazioneLogica(idAccettazione))
            .then((data) => {
                setLoading(false);
                // Controllo se bisonga aggiornare la worklist
                if (abilitaWorkList) {
                    const message = {
                        Stampante: "",
                        Data: data.message,
                        command: "WORKLIST",
                        id: 0
                    };
                    webSocketService.sendMessage(message);
                }
                window.location.reload();
            })
            .catch((error) => {
                console.log(error);
            });
        setIDAccettazione(0);
    }

    const clearDate = () => {
        const today = getDataPerDataPicker(Date.now());
        setSelectedDate(today);
        handleCarica(today);
    };

    const handleRitira = (id) => {
        setIdRitiro(id)
        setShow(true);
    }

    const handleClose = () => {
        setIdRitiro(0);
        setShow(false);
    }
    const getColorSaldo = (saldo) => {
        if (saldo < 0)
            return "text-success";
        if (saldo === 0)
            return "text-muted";
        if (saldo > 0)
            return "text-danger";
    }

    const normalizzaSesso = (value) => {
        // Se è booleano, lo uso così com'è
        if (typeof value === 'boolean') return value;

        // Se è stringa, la confronto in modo case-insensitive
        if (typeof value === 'string') {
            const v = value.trim().toLowerCase();
            if (v === 'true') return true;
            if (v === 'false') return false;
        }

        return null;
    };

    return (
        <div>
            <BasicModal
                show={isDelete}
                title="Cancella accettazione"
                body={modalBody}
                onClose={handleCloseDelete}
                showConfirm={showConfirm}
                onConfirm={showConfirm ? handleConfermaCancella : undefined}
            />
            <Breadcrumb
                routeSegments={[
                    { name: "Accettazioni", path: "/accettazione/menu" },
                    { name: "Impegnative NRE" },
                ]}
            />
            <div id="task-manager-list">
                {/* <!-- content area --> */}
                <div className="content">
                    {/* <!-- task manager table --> */}
                    <div>
                        <div className="bg-transparent mb-3">
                            <label className="mb-2 mx-1" htmlFor="datePicker">Ricerca per data prenotazione</label>
                            <div className="row">
                                <div className="col-2">
                                    <input
                                        className="form-control date-input"
                                        type="date"
                                        id="datePicker"
                                        value={dataPrenotazione}
                                        onChange={handleDateChange}
                                    />
                                </div>
                                <div className="col-2">
                                    <button className="btn btn-secondary w-50" onClick={clearDate}>Oggi</button>
                                </div>
                            </div>
                        </div>
                        {isLoading ? (
                            <LoadingSpinner />
                        ) : (
                            <div className="table-responsive">
                                <table id="tableGenerale" className="table">
                                    <tbody id="tBodyGenerale">
                                        {elencoAnagrafiche.map((gruppo, indGruppo) => {
                                            const anagrafica = gruppo?.anagrafica;
                                            const accettazioni = gruppo?.accettazioni ?? [];

                                            return (
                                                <Fragment key={`anag-${anagrafica?.idanagrafica ?? indGruppo}`}>
                                                    {/* Riga intestazione anagrafica */}
                                                    <tr>
                                                        <td colSpan="12" className="align-middle rounded" style={{ borderTop: "2px solid black", borderBottom: "2px solid black", }} >
                                                            <div className=" d-flex align-items-center flex-wrap gap-3 p-2 rounded" style={{ backgroundColor: "#faf4d9ff" }}>
                                                                <h5 className="fw-bolder m-0">
                                                                    {anagrafica.cognome} {anagrafica.nome}:
                                                                </h5>

                                                                <h6 className="fw-bold m-0">
                                                                    {anagrafica.codiceFiscale}
                                                                </h6>

                                                                <h6 className="m-0">
                                                                    {anagrafica.dataNascitaAsString} - {anagrafica.comuneNascitaAsString}
                                                                </h6>

                                                                <h6 className="m-0">
                                                                    {normalizzaSesso(anagrafica.sesso) === true ? (
                                                                        <span className="d-inline-flex align-items-center">
                                                                            <i className="fw-bold i-Male-2 text-primary"></i>
                                                                            <span className="ms-1">Maschio</span>
                                                                        </span>
                                                                    ) : (
                                                                        <span className="d-inline-flex align-items-center">
                                                                            <i className="fw-bold i-Female-2 text-primary"></i>
                                                                            <span className="ms-1">Femmina</span>
                                                                        </span>
                                                                    )}
                                                                </h6>
                                                            </div>
                                                        </td>
                                                    </tr>

                                                    {/* Accettazioni della stessa anagrafica */}
                                                    {accettazioni.map((task, ind1) => (
                                                        <Fragment key={`acc-${task.idaccettazione ?? `${indGruppo}-${ind1}`}`}>
                                                            {/* Riga intestazione accettazione */}
                                                            <tr>
                                                                <th colSpan="12" className="align-middle p-0 rounded" style={{ backgroundColor: "#f7f7f7" }}>
                                                                    <div className="mt-2 p-2">
                                                                        <div className="d-flex justify-content-start align-items-center">
                                                                            <div className="col-4">
                                                                                <h5>
                                                                                    <span className="fw-semibold me-2">Data:</span>{formattaDataOraHHmm(task.dataOra)}
                                                                                    <span className="fw-semibold me-2 ms-3">Codice:</span>{task.codice}
                                                                                </h5>
                                                                            </div>

                                                                            <div className="col-2">
                                                                                {(!task.isFatturata && !task.isRefertata) && (
                                                                                    <button
                                                                                        className="btn btn-outline-danger w-75"
                                                                                        title="Cancella accettazione"
                                                                                        onClick={() => handleDelete(task)}
                                                                                    >
                                                                                        <i className="i-Close me-1"></i> Cancella accettazione
                                                                                    </button>
                                                                                )}

                                                                                {task.isRefertata && (
                                                                                    <button
                                                                                        className="btn btn-outline-info w-75"
                                                                                        title="Ritiro referti"
                                                                                        onClick={() => handleRitira(task.id)}
                                                                                    >
                                                                                        <i className="i-File-Clipboard-File--Text me-1"></i> Ritiro referti
                                                                                    </button>
                                                                                )}
                                                                            </div>

                                                                            <div className="col-2" style={{ fontSize: "1rem" }}>
                                                                                <span className={`me-2 fw-bold ${getColorSaldo(task.saldo)}`}>
                                                                                    Saldo: {formatEuro(task.saldo)}
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </th>
                                                            </tr>

                                                            {/* Righe dettagli (identiche alle tue) */}
                                                            {(task.dettaglioAccettaziones?.length ?? 0) === 0 ? (
                                                                <tr key={`vuoto-${indGruppo}-${ind1}`}>
                                                                    <td colSpan="12"></td>
                                                                </tr>
                                                            ) : (
                                                                task.dettaglioAccettaziones.map((itemDettaglio, ind) => (
                                                                    <tr key={`${indGruppo}-${ind1}-${ind}`} id={ind1}>
                                                                        <th scope="row" className="head-width">
                                                                            #{ind + 1}
                                                                        </th>

                                                                        <td className="collection-item">
                                                                            <div className="font-weight-bold">
                                                                                {formatImpegnativa(itemDettaglio)}
                                                                            </div>
                                                                            <div className="text-muted">
                                                                                {itemDettaglio.esame.codiceMinisteriale}
                                                                                {"\t"}
                                                                                {itemDettaglio.esame.descrizione}
                                                                            </div>
                                                                        </td>

                                                                        <td className="custom-align">
                                                                            <div className="btn-group ">
                                                                                {itemDettaglio.prezzo}
                                                                            </div>
                                                                        </td>

                                                                        <td className="custom-align">
                                                                            <div className="d-inline-flex align-items-center calendar align-middle">
                                                                                <i className="i-Letter-Open"></i>
                                                                                {itemDettaglio.dataRefertazione === "1900-01-01T00:00:00" ? (
                                                                                    <span>Da Refertare</span>
                                                                                ) : (
                                                                                    formattaDataOraHHmmss(itemDettaglio.dataRefertazione)
                                                                                )}
                                                                            </div>
                                                                        </td>

                                                                        <td className="custom-align">
                                                                            <select
                                                                                className="form-control custom-select task-manager-list-select"
                                                                                id="inputGroupSelect01"
                                                                                onChange={(e) => handleSelectChange(e, anagrafica.idanagrafica)}
                                                                                value="0"
                                                                            >
                                                                                <option value="0">Scegli...</option>
                                                                                <option value={`1_${task.idaccettazione}`}>Apri accettazione</option>

                                                                                {task.fattureInfos.map((fattura) => (
                                                                                    <option key={fattura.idFattura} value={`2_${fattura.idFattura}`}>
                                                                                        {fattura.numeroFattura} - Stampa
                                                                                    </option>
                                                                                ))}

                                                                                {itemDettaglio.idmedicoRefertante > 0 ? (
                                                                                    <option value={`3_${itemDettaglio.iddettaglio}`}>Stampa referto</option>
                                                                                ) : (
                                                                                    ""
                                                                                )}
                                                                            </select>
                                                                        </td>
                                                                    </tr>
                                                                ))
                                                            )}
                                                            <tr key={`vuoto-${ind1}`}>
                                                                <td colSpan="12"></td>
                                                            </tr>
                                                        </Fragment>
                                                    ))}

                                                </Fragment>

                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <RitiriModalForm open={show} idAccettazione={idRitiro} closeDialog={handleClose} />
        </div >
    )
}
export default ImpegnativeNre;